// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis":"Loading_ldsEllipsis__Oct_f","ldsEllipsis1":"Loading_ldsEllipsis1__K_5Id","ldsEllipsis2":"Loading_ldsEllipsis2__ssP96","ldsEllipsis3":"Loading_ldsEllipsis3__UpnEe"};